import { INTERVENE_USER_TABS } from '../constants/interveneApi';

export const USER_LIST_BADGE_MODE = {
  EXPIRED: 'expired',
  TIMER: 'timer',
  NONE: 'none',
};

/**
 * History → always Expired.
 * Intervene / 15 Min / 24 HRS → tab-aware countdown (15m vs 24h window).
 */
export function getUserListBadgeMode(userType) {
  if (userType === INTERVENE_USER_TABS.HISTORY) {
    return USER_LIST_BADGE_MODE.EXPIRED;
  }

  if (
    userType === INTERVENE_USER_TABS.INTERVENE ||
    userType === INTERVENE_USER_TABS.RECENT_15M ||
    userType === INTERVENE_USER_TABS.ACTIVE_24H
  ) {
    return USER_LIST_BADGE_MODE.TIMER;
  }

  return USER_LIST_BADGE_MODE.NONE;
}
